import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../components/Icon/Icon";
import { IconButton } from "@mui/material";
import { colors } from "../../../styles/colors";
import { useNavigate } from "react-router";

type props = {
  vehicle: TVehicule;
};

export const ButtonsListVehicle: FC<props> = ({ vehicle }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClickVehicle = () => {
    navigate(`/vehicule/update/${vehicle.vehicleId}`);
  };

  const onClickBatteryHealth = () => {
    navigate(`/vehicule/battery-health/${vehicle.vehicleId}`);
  };

  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      {/* Always visible */}
      <IconButton
        aria-label={t("a11y.viewVehicle", "View vehicle")}
        onClick={onClickVehicle}
      >
        <Icon name="eye" width={"24px"} height={"24px"} color={colors.BLACK} />
      </IconButton>

      {/*
        Battery health is a LinkByCar read, so the button must only exist when
        the provider has actually confirmed this vehicle - not merely when the
        legacy boolean is truthy.

        In practice `lbc_eligibilty` gave the same answer here, but by accident
        rather than by intent: it is `false` for "provider said no" AND for
        "never asked", and the two happened to coincide. Keying on the explicit
        status makes the rule readable and survives the day the legacy flag is
        removed. `plan_excluded` and `pending` both correctly hide the button:
        clicking through to an endpoint that will 403 or return nothing is a
        worse experience than not offering it.
      */}
      {vehicle.telematics?.status === "eligible" && (
        <IconButton
          aria-label={t("a11y.batteryHealth", "Battery health")}
          onClick={onClickBatteryHealth}
        >
          <Icon
            name="battery"
            width={"24px"}
            height={"24px"}
            color={colors.BLACK}
          />
        </IconButton>
      )}
    </div>
  );
};
